import * as types from '../types/siteTypes';
import * as siteServices from '../../services/siteServices';
import { sitePathSlug } from '../../utils/sitePathSlug';

export const fetchSites = (params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_SITES_REQUEST });
  try {
    const response = await siteServices.getSites(params);
    dispatch({ type: types.FETCH_SITES_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch sites';
    dispatch({ type: types.FETCH_SITES_FAILURE, payload: message });
  }
};

export const fetchTopSites = (params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_TOP_SITES_REQUEST });
  try {
    const response = await siteServices.getTopSites(params);
    dispatch({ type: types.FETCH_TOP_SITES_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch top sites';
    dispatch({ type: types.FETCH_TOP_SITES_FAILURE, payload: message });
  }
};

export const fetchCategories = () => async (dispatch) => {
  dispatch({ type: types.FETCH_CATEGORIES_REQUEST });
  try {
    const response = await siteServices.getCategories();
    dispatch({ type: types.FETCH_CATEGORIES_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch categories';
    dispatch({ type: types.FETCH_CATEGORIES_FAILURE, payload: message });
  }
};

export const fetchSiteByDomain = (domain) => async (dispatch) => {
  dispatch({ type: types.FETCH_SITE_REQUEST });
  try {
    const response = await siteServices.getSiteByDomain(domain);
    dispatch({ type: types.FETCH_SITE_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch site';
    dispatch({ type: types.FETCH_SITE_FAILURE, payload: message });
  }
};

/** Similar page: load base site then similar list in one flow so Redux never shows “empty” before similar fetch starts. */
export const fetchSiteAndSimilarForSimilarPage = (slug) => async (dispatch) => {
  dispatch({ type: types.FETCH_SITE_REQUEST });
  try {
    const response = await siteServices.getSiteByDomain(slug);
    dispatch({ type: types.FETCH_SITE_SUCCESS, payload: response });
    const mainDomain = sitePathSlug(response);
    dispatch({ type: types.FETCH_SIMILAR_REQUEST });
    try {
      const list = await siteServices.getSimilarSites(mainDomain);
      dispatch({ type: types.FETCH_SIMILAR_SUCCESS, payload: list });
    } catch (simError) {
      const message = simError.response?.data?.message || simError.message || 'Failed to fetch similar sites';
      dispatch({ type: types.FETCH_SIMILAR_FAILURE, payload: message });
    }
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch site';
    dispatch({ type: types.FETCH_SITE_FAILURE, payload: message });
  }
};

export const fetchReviewsByDomain = (domain, params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_REVIEWS_REQUEST });
  try {
    const response = await siteServices.getReviewsByDomain(domain, params);
    dispatch({ type: types.FETCH_REVIEWS_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch reviews';
    dispatch({ type: types.FETCH_REVIEWS_FAILURE, payload: message });
  }
};

export const fetchSponsoredByDomain = (domain) => async (dispatch) => {
  dispatch({ type: types.FETCH_SPONSORED_REQUEST });
  try {
    const response = await siteServices.getSponsoredByDomain(domain);
    dispatch({ type: types.FETCH_SPONSORED_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch sponsored items';
    dispatch({ type: types.FETCH_SPONSORED_FAILURE, payload: message });
  }
};

export const submitReview = (domain, data) => async (dispatch, getState) => {
  try {
    const token = getState().auth.token;
    await siteServices.createReview(domain, data, token);
    dispatch(fetchReviewsByDomain(domain));
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to submit review';
    return { success: false, message };
  }
};

export const fetchSimilarSites = (mainDomain) => async (dispatch) => {
  dispatch({ type: types.FETCH_SIMILAR_REQUEST });
  try {
    const list = await siteServices.getSimilarSites(mainDomain);
    dispatch({ type: types.FETCH_SIMILAR_SUCCESS, payload: list });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch similar sites';
    dispatch({ type: types.FETCH_SIMILAR_FAILURE, payload: message });
  }
};

export const submitSimilarityVote = (mainDomain, alternativeDomain, rating, reason) => async (dispatch) => {
  try {
    await siteServices.submitSimilarityVote(mainDomain, { alternativeDomain, rating, reason });
    dispatch(fetchSimilarSites(mainDomain));
    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to submit vote';
    return { success: false, message };
  }
};

export const clearSiteState = () => ({ type: types.CLEAR_SITE_STATE });

